/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { Link, withRouter } from 'react-router-dom';
import axios from 'axios';
import lodash from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import * as action from '../actions'
import config from '../config';
import ErrorIcon from '../assets/SVG/icons/error-icon.svg';
import EyeIconOn from '../assets/SVG/icons/eye-icon-active.svg';
import EyeIconOff from '../assets/SVG/icons/eye-icon.svg';
import EmailIcon from '../assets/SVG/icons/email-icon.svg';
import 'react-toastify/dist/ReactToastify.css';
import '../styles/login.css';
import useToastify from "../hooks/useToastify";

axios.defaults.withCredentials = true;

const PlatformNotAllowedMessage = () => (
    <div>
      You cannot access this version of the iSelfie Test application. Please <a href={config.enterprise.url} >click here</a> for Enterprise Platform
    </div>
  );

function LogIn(props) {
    const dispatch = useDispatch();
    const [ user ] = useState(useSelector((state) => state.user));
    const { notifySuccess, notifyError } = useToastify();

    const [state , setState] = useState({
        email : "",
        password : "",
        showPassword: false,
        isPassNull: false,
        isEmailNull: false,
        isLoginFailure: false,
        isUserInactive: false,
        isUserBlocked: false,
        errMsg: "",
        errMsgEmail: "",
        isLoading: false
    });

    const handleChange = (e) => {
        const {id , value} = e.target;
        setState(prevState => ({
            ...prevState,
            [id] : value
        }));
    };

    const toggleShowPassword = (e) => {
        setState(prevState => ({
            ...prevState,
            showPassword: !state.showPassword
        }));
    }

    const handleSubmitClick = (e) => {
        e.preventDefault();
        props.setSignup(false);

        setState(prevState => ({
            ...prevState,
            isPassNull: false,
            isEmailNull: false,
            isLoginFailure: false,
            isUserInactive: false,
            isUserBlocked: false,
            errMsg: "",
            errMsgEmail: "",
            isLoading: true
        }));

        if(state.email === "") {
            setState(prevState => ({
                ...prevState,
                isEmailNull : true,
                isLoading: false
            }));
        }
        else if (state.password === "") {
            setState(prevState => ({
                ...prevState,
                isPassNull : true,
                isLoading: false
            }));
        }
        else if (state.email && !isValidEmail(state.email)) {
            setState(prevState => ({
                ...prevState,
                errMsgEmail : "Invalid Email!",
                isLoading: false
            }));
        }
        else {
            sendDetailsToServer();
        }
    };

    const sendDetailsToServer = () => {
        const payload={
            "email": state.email.trim().toLowerCase(),
            "pw": state.password,
        };

        axios.post(config.backend_url+'/signin', payload)
        .then( (response) => {
            if(response.status === 200){
                //storing user details into redux for using it into the other pages of application
                let setUser = {
                    uid: response.data.user.uid,
                    firstName: response.data.user.firstName,
                    lastName: response.data.user.lastName,
                    last_visit: response.data.user.last_visit,
                    verified: response.data.user.verified,
                    picture: response.data.user.picture,
                    loggedIn_time: new Date().getTime(),
                    ...response.data.user.privilege
                };
                dispatch(action.updateUser(setUser));
                //redirecting to homepage on successful login
                props.history.push('/home');
                // temporary hotfix until mobile version fix is issued
                // window.location.reload();
            } else {
                setState(prevState => ({
                    ...prevState,
                    isLoginFailure : true,
                    isLoading: false
                }));
                // notifyError("Login Failure!");
            }
        })
        .catch( (error) => {
            console.error(error);
            if(error.response) {
                if (error.response.status === 403) {
                    if (error.response.data.errorMsg.includes("blocked")) {
                        setState(prevState => ({
                            ...prevState,
                            isUserBlocked: true,
                            errMsg: error.response.data.errorMsg
                        }));
                        notifyError(error.response.data.errorMsg);
                    } 
                    else if (error.response.data.userStatus.includes("Inactive")) {
                        setState(prevState => ({
                            ...prevState,
                            isUserInactive: true,
                            errMsg: error.response.data.errorMsg
                        }));
                        notifyError(error.response.data.errorMsg);
                    }
                    else if (error.response.data.userStatus.includes("NotFound")) {
                        setState(prevState => ({
                            ...prevState,
                            isUserInactive: true,
                            errMsg: error.response.data.errorMsg
                        }));
                        notifyError("Username/Password is invalid");
                    }
                    else if (error.response.data.userStatus.includes("PlatformNotAllowed")) {
                        setState(prevState => ({
                            ...prevState,
                            isUserInactive: true,
                            errMsg: error.response.data.errorMsg
                        }));
                        notifyError(PlatformNotAllowedMessage);
                    }
                    else if (error.response.data.userStatus.includes("tooManyRequest")) {
                        setState(prevState => ({
                            ...prevState,
                            isUserInactive: true,
                            errMsg: error.response.data.errorMsg
                        }));
                        notifyError(error.response.data.errorMsg);
                    }
                }
                else {
                    setState(prevState => ({
                        ...prevState,
                        isLoginFailure: true,
                        errMsg: error.response.data.errorMsg
                    }));

                    error.response.data.errorMsg ? notifyError(error.response.data.errorMsg) : notifyError("Login Failure!")
                }
            }
            else {
                notifyError("Network Error!");
            }
            setState(prevState => ({
                ...prevState,
                isLoading: false
            }));
        });
    };

    const isValidEmail = (text) => {
        let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return text.toLowerCase().match(re);
    };

    useEffect(() => {
        document.title = "Sign in";
        if(props.signUp) notifySuccess("Registration was successful! Please log in now!")
        if(props.location.state?.passwordReset) notifySuccess("Password changed successful! Please log in now!")
        //if user is already logged in then redirect to homepage
        if(!lodash.isEmpty(user)) {
            props.history.push('/home');
        }
    }, []);

    return (
        <div className="container">
            <div className="main signin-form" data-testid="signin-form">
                {state.isLoading ? <div id="loading-spin"></div> : <></>}
                <p className="heading">Log In</p>
                <div className='wrapper'>
                <form  id='login' onSubmit={handleSubmitClick}>
                    <div className="form-group" data-testid="form-group">
                        <label className="label">E-mail</label>
                        <div className="input-box">
                            <input type="email" id="email" className={ "form-control " + (state.email ? "navy-text " : "") + ((state.isEmailNull || state.errMsgEmail) ? "red-border " : "")} 
                                placeholder="e-mail@address.com" value={state.email} onChange={handleChange} required/>
                            <img src={EmailIcon} alt="email icon" />
                        </div>
                        {state.isEmailNull ? <p><img src={ErrorIcon} alt="err"/>Email is Required!</p> : <></>}
                        {state.errMsgEmail ? <p><img src={ErrorIcon} alt="err"/>{state.errMsgEmail}</p> : <></>}
                    </div>

                    <div className="form-group" data-testid="form-group">
                        <label className="label">Password</label>
                        <div className='input-box'>
                            <input type={state.showPassword ? "text" : "password"} id="password" className={ "form-control " + (state.password ? "navy-text " : "") + (state.isPassNull ? "red-border " : "")} 
                                placeholder="Password" value={state.password} onChange={handleChange} required/>
                            <img src={state.showPassword ? EyeIconOn : EyeIconOff} alt="password icon" className='pointer' onClick={toggleShowPassword}/>
                        </div>   
                        {state.isPassNull ? <p><img src={ErrorIcon} alt="err"/>Password is Required!</p> : <></>}
                    </div>
                    <p className="forgot-password text-right"><Link to="/forgot-password">Forgot password?</Link></p>

                    <div className="btn-submit">
                        <button type="submit">Log In</button>
                    </div>
                </form>
                </div>
                <div className="signup-link" data-testid="signup-link">
                    <p>Do not have an account? <Link to='/signup'> <span>Sign Up</span></Link></p>
                </div>
            </div>
        </div>
    )
}

export default withRouter(LogIn);
